import * as qs from "qs"

export async function getFilteredData(query) {
  let dataLoading = document.querySelector(".js-filtered-data .js-loading")
  let dataBody = document.querySelector(".js-filtered-data .js-body")

  let parsed = qs.parse(query, { comma: true })
  parsed["data_only"] = true
  let queryForFetch = qs.stringify(parsed, { arrayFormat: "comma" })

  if (dataBody && dataLoading) {
    dataBody.classList.add("js-hidden")
    dataLoading.classList.remove("js-hidden")

    if (window.location.search !== `?${query}`) {
      history.replaceState({}, "", `${window.location.pathname}?${query}`)
    }

    let html = await getHTML(`${window.location.pathname}?${queryForFetch}`)
    dataBody.innerHTML = html

    dataLoading.classList.add("js-hidden")
    dataBody.classList.remove("js-hidden")
  }
}

function getHTML(uri) {
  return fetch(uri, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Cache-Control": "no-cache",
    },
    mode: "same-origin",
    credentials: "same-origin",
  }).then(function (response) {
    if (response.ok) {
      return response.text()
    } else {
      throw "Request failed"
    }
  })
}
